<!-- @veltra/icons generated sha256:f21c5621439c11f4 gen:8 source:src/svg/normal/circle-check.svg -->
<script setup lang="ts">
defineOptions({ name: 'CircleCheck' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12m-1.353-3.646L4.853 8.56a.486.486 0 0 1-.01-.695l.008-.008a.504.504 0 0 1 .71-.002L7 9.293l3.443-3.443a.483.483 0 0 1 .693-.007l.008.008a.506.506 0 0 1 0 .712l-3.788 3.789a.5.5 0 0 1-.709.002"
    />
  </svg>
</template>
